/**
 * File picker input with **`qz-input`** styling.
 *
 * @param options - **`id`**, optional **`accept`**, disabled.
 * @returns Native **`input[type=file]`** (wrap with **`createField`** for a labelled row).
 */
export function createFileInput(
  options: Readonly<{
    id: string;
    name?: string;
    accept?: string;
    disabled?: boolean;
  }>,
): HTMLInputElement {
  const input = document.createElement("input");
  input.type = "file";
  input.className = "qz-input qz-input--file";
  if (options.name !== undefined) {
    input.name = options.name;
  }
  if (options.accept !== undefined) {
    input.accept = options.accept;
  }
  if (options.disabled === true) {
    input.disabled = true;
  }
  input.id = options.id;
  return input;
}
